import {$, w} from './constants';

$(document).ready(function() {

    if($('#video-portada').length){
        Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
            get: function () {
                return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
            }
        });
        console.log('custom video');
        const video = $('#video-portada').get(0);
        const videoContainer = document.getElementById('container-video');

        var pausing_function = function(){
            if(this.currentTime >= 10) {
                this.pause();
                console.log('lets put a button')
                $('.hero__video-continue').addClass('show');
                // remove the event listener after you paused the playback
                this.removeEventListener("timeupdate",pausing_function);
            }
        };

        $('#play').click(function(){
            $(this).parent().removeClass('show');

            video.play();
        })

        
        video.addEventListener("timeupdate", pausing_function);

        //Fallback para iOS 
       /*  //Code https://shaktisinghcheema.com/how-to-autoplay-video-on-mobile-devices-on-low-power-mode/
        $('body').on('click touchstart', function () {
            const videoElement = document.getElementById('video-portada');
            if (videoElement.playing) {
                // video is already playing so do nothing
            }
            else {
                // video is not playing
                // so play video now
                videoElement.play();
            }
        }); */
        
        $('#audio').click(function(){
            video.muted = !video.muted;

            if(!video.muted){
                video.volume = 0.2;
            }

            $(this).toggleClass('on');
        })
        
        const vol_array = document.querySelectorAll('span.audio_vol');
        
        Array.from(vol_array).forEach((vol) =>{
            $(vol).click(function(){
                $('span.audio_vol').removeClass('check');
                $(this).toggleClass('check');
                const vol_info = $(this).data('vol');
                console.log(vol_info)
                switch (vol_info) {
                    case 'vol1':
                      console.log('volumen 1');
                      $('span.audio_vol').removeClass('check');
                      $('.vol_1').addClass('check');
                      video.volume = 0.2;
                      break;
                    case 'vol2':
                      console.log('volumen 2');
                        $('.vol_1').addClass('check');
                        $('.vol_2').addClass('check');
                        $('.vol_3').removeClass('check');
                        $('.vol_4').removeClass('check');
                        $('.vol_5').removeClass('check');
                        video.volume = 0.4;
                      break;
                    case 'vol3':
                        console.log('volumen 3');
                        $('.vol_1').addClass('check');
                        $('.vol_2').addClass('check');
                        $('.vol_3').addClass('check');
                        $('.vol_4').removeClass('check');
                        $('.vol_5').removeClass('check');
                        video.volume = 0.6;
                        break;
                    case 'vol4':
                        console.log('volumen 4');
                        $('.vol_1').addClass('check');
                        $('.vol_2').addClass('check');
                        $('.vol_3').addClass('check');
                        $('.vol_4').addClass('check');
                        $('.vol_5').removeClass('check');
                        video.volume = 0.8;
                        break;
                    case 'vol5':
                        console.log('volumen 5');
                        $('span.audio_vol').addClass('check');
                        video.volume = 1;
                        break;
                    default:
                        console.log('volumen 1');
                        $('span.audio_vol').removeClass('check');
                        $('.vol_1').addClass('check');
                        video.volume = 0.2;
                  }
            })
        });

        const fullScreenEnabled = !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.createElement('video').webkitRequestFullScreen);
        if (!fullScreenEnabled) {
            console.log('No soporta fullscreen :(');
            $('.hero__video-controls').addClass('ios');
            $('.audio-main').addClass('hide');
            $('.hero__video').addClass('ios fix-vh');
            $('.hero__audio-ios').addClass('show');
            $('.video__fullscreen').addClass('hide');
            $('.arrow-down').addClass('ios');
            $('.arrow-page').addClass('ios');
            //video.pause();
        }
        $('#fullscreen').click(function(){
            if (isFullScreen()) {
                if (document.exitFullscreen) document.exitFullscreen();
                else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
                else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
                else if (document.msExitFullscreen) document.msExitFullscreen();
                setFullscreenData(false);
             }
             else {
                if (videoContainer.requestFullscreen) videoContainer.requestFullscreen();
                else if (videoContainer.mozRequestFullScreen) videoContainer.mozRequestFullScreen();
                else if (videoContainer.webkitRequestFullScreen) videoContainer.webkitRequestFullScreen();
                else if (videoContainer.msRequestFullscreen) videoContainer.msRequestFullscreen();
                setFullscreenData(true);
             }
        })

        $('.hero__audio-ios').click(function(){
            video.muted = !video.muted;
            //video.play();
            $(this).toggleClass('on');
        })

        const isFullScreen = function() {
            return !!(document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
        }

        const setFullscreenData = function(state) {
            videoContainer.setAttribute('data-fullscreen', !!state);
            if(state){
                $('#fullscreen').addClass('exit');
                $(video).addClass('fullscreen-size');
                var timeout = null;
                $(video).on('mousemove', function() {
                    clearTimeout(timeout);
                    $('.hero__video-controls').removeClass('fullscreen-controls');
                    timeout = setTimeout(function() {
                        $('.hero__video-controls').addClass('fullscreen-controls');
                    }, 3000);
                });
                console.log('Entre')
            }else{
                $(video).removeClass('fullscreen-size');
                $('#fullscreen').removeClass('exit');
                console.log('Sali')
            }
        }

        document.addEventListener('fullscreenchange', function(e) {
            setFullscreenData(!!(document.fullscreen || document.fullscreenElement));
         });
         document.addEventListener('webkitfullscreenchange', function() {
            setFullscreenData(!!document.webkitIsFullScreen);
         });
         document.addEventListener('mozfullscreenchange', function() {
            setFullscreenData(!!document.mozFullScreen);
         });
         document.addEventListener('msfullscreenchange', function() {
            setFullscreenData(!!document.msFullscreenElement);
         });
    }

})
